import { render, staticRenderFns } from "./FluxoCaixaTabela.vue?vue&type=template&id=37111472&scoped=true&"
import script from "./FluxoCaixaTabela.vue?vue&type=script&lang=js&"
export * from "./FluxoCaixaTabela.vue?vue&type=script&lang=js&"
import style0 from "./FluxoCaixaTabela.vue?vue&type=style&index=0&id=37111472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37111472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37111472')) {
      api.createRecord('37111472', component.options)
    } else {
      api.reload('37111472', component.options)
    }
    module.hot.accept("./FluxoCaixaTabela.vue?vue&type=template&id=37111472&scoped=true&", function () {
      api.rerender('37111472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/FluxoCaixaGerencial/FluxoCaixaTabela.vue"
export default component.exports